import classNames from 'classnames';
import * as React from 'react';
import MerchantCategory from '../../../../domain/entities/MerchantCategory';
import css from './index.module.scss';
import ServiceFooter from './ServiceFooter';
import SiteFooter from './SiteFooter';

export interface Props {
  categories?: MerchantCategory[];
  hideBlandContent?: boolean;
  isMerchantStickyFooterExist: boolean;
}

class MerchantGlobalFooter extends React.PureComponent<
  Props & React.HTMLProps<{}>
> {
  public static defaultProps: Props = {
    categories: [],
    hideBlandContent: false,
    isMerchantStickyFooterExist: false,
  };

  public render() {
    const {
      categories,
      hideBlandContent,
      isMerchantStickyFooterExist,
    } = this.props;

    const baseClasses = classNames(css.MerchantGlobalFooter, {
      [css.StickyFooterPadding]: isMerchantStickyFooterExist,
    });

    return (
      <footer className={baseClasses}>
        {categories && categories.length > 0 && !hideBlandContent && (
          <ServiceFooter categories={categories} />
        )}
        <SiteFooter />
      </footer>
    );
  }
}

export default MerchantGlobalFooter;
